export const SEARCHED_FOR_SITTER_EVENT_NAME = 'Searched For Sitter';
export const UPDATE_SITTER_SEARCH_EVENT_NAME = 'Update Sitter Search';
export const UPDATE_FILTER_LOCATION_EVENT_NAME = 'Search Sitter Filter Location';
export const UPDATE_FILTER_SERVICE_EVENT_NAME = 'Search Sitter Filter Service';
export const UPDATE_FILTER_PETS_EVENT_NAME = 'Search Sitter Filter Pets';
export const UPDATE_FILTER_OVERNIGHT_CALENDAR_EVENT_NAME =
  'Search Sitter - Overnight Service - Calendar Update';
export const UPDATE_FILTER_REPEAT_WEEKLY_CALENDAR_EVENT_NAME =
  'Search Sitter - Daytime Service - RWB - Calendar Update';
export const UPDATE_FILTER_ONE_OFF_CALENDAR_EVENT_NAME =
  'Search Sitter - Daytime Service - One Off - Calendar Update';
export const VIEWED_SERVICE_DESCRIPTIONS_EVENT_NAME = 'Viewed service descriptions';

// Pet Profile
export const EDITED_PET_PROFILE_EVENT_NAME = 'Edited Pet Profile';
export const VIEWED_PET_PROFILE_EVENT_NAME = 'Viewed Pet Profile';
export const PET_PROFILE_VIEW_CLICK_TAB_EVENT_NAME = 'Pet Profile View - Click Tab';

export const VIEWED_HOME_PAGE = 'Viewed Homepage';
export const CLICKED_HOW_IT_WORKS = 'Homepage - CTA - How it works';
export const CLICKED_NAVIGATION_ITEM = 'Navigation Item Click';
export const CLICKED_SERVICE_TAB = 'Homepage - Services Tab Clicked';
export const CLICKED_EXPANDED_SEARCH_DESKTOP = 'Pop up - Sitter Search';
export const CLICKED_EXPANDED_SEARCH_MOBILE = 'Expanded Mobile - Sitter Search';
export const UPDATE_SORT_SITTERS = 'SFS - Sort Sitters';
export const UPDATE_FILTER_SITTERS = 'SFS - Filter Sitters';
export const UPDATE_PRICE_FILTER_SITTERS = 'SFS - Price filter sitters';
export const UPDATE_MIN_REVIEWS_FILTER_SITTERS = 'SFS - Min Reviews filter sitters';
export const CLICKED_SITTER_CARD_EVENT_NAME = 'Searched For Sitter - Sitter Clicked';
export const EDIT_SEARCH_CLICKED = 'Edit Search Clicked';

// Service Landing Page
export const VIEWED_SLP_EVENT_NAME = 'Viewed Service Landing Page';
export const CLICKED_SLP_MOBILE_SEARCH_CTA_EVENT_NAME =
  'Service Landing Page - Mobile - CTA - Trigger Search';
export const UPDATE_SITTER_SEARCH_SLP_MOBILE_EVENT_NAME =
  'Service Landing Page - Mobile - Update Sitter Search  ';
export const CLICKED_PET_PRODUCT_SERVICE = 'Pet Product Click';
export const OTHER_BRAND_CROSS_SELL_CLICK = 'Other Brand Cross-Sell Click';
export const MOBILE_APP_DOWNLOAD_BANNER_CLICK_EVENT_NAME = 'Mobile App Download Banner Clicked';

// Google Auth
export const CLICKED_VERIFY_MOBILE_EVENT_NAME = 'User Verify Mobile Clicked';
export const MOBILE_VERIFIED_EVENT_NAME = 'User Mobile Verified';
export const VIEWED_CONFIRM_NAME_AND_ACCEPT_TERMS_EVENT_NAME =
  'Viewed confirm name and accept terms screen';
export const VIEWED_MOBILE_VERIFICATION_EVENT_NAME = 'Viewed Mobile Verification Screen';
export const VIEWED_TWO_FACTOR_CODE_EVENT_NAME = 'Viewed Two Factor Code Screen';
export const SIGNED_UP_FE_EVENT_NAME = 'Signed Up FE';

// Auth Dialog
export const USER_LOG_IN_COMPLETED_EVENT_NAME = 'User Log In Competed';
export const LOGGED_IN_FE_EVENT_NAME = 'Logged In FE';
export const USER_CONTINUE_LOGIN_CLICK_EVENT_NAME = 'User Continue Login Click';
export const LOGIN_MODAL_VIEWED_EVENT_NAME = 'Login Modal Viewed';
export const USER_LOGGED_OUT_EVENT_NAME = 'User Logged Out';
export const USER_SIGNUP_CLICK_EVENT_NAME = 'User SignUp Click';
export const USER_SIGNUP_COMPLETED_EVENT_NAME = 'User SignUp Completed';

// Sitter Profile
export const VIEWED_SITTER_PROFILE_EVENT_NAME = 'Viewed Sitter Profile';
export const CLICKED_CONTACT_SITTER_EVENT_NAME = 'Clicked Contact Sitter';
export const SHARED_SITTER_PROFILE_EVENT_NAME = 'Shared Sitter Profile';
export const CLICKED_EXPAND_SITTER_BIO_EVENT_NAME = 'Clicked Expand Sitter Bio';
export const VIEWED_SITTER_PHOTO_GALLERY_EVENT_NAME = 'Viewed Sitter Photo Gallery';
export const CLICKED_LEARN_ABOUT_ACCIDENT_COVER_EVENT_NAME = 'Clicked Learn About Accident Cover';
export const CLICKED_LEARN_ABOUT_CANCELLATION_EVENT_NAME = 'Clicked Learn About Cancellation';
export const VIEWED_ADDITIONAL_RATES_EVENT_NAME = 'Viewed Additional Rates';

export const SITTER_UNFAVOURITE_CLICK = 'Sitter Unfavourite Click';
export const SITTER_FAVOURITED_CLICK = 'Sitter Favourited Click';
export const SITTER_FAVOURITED_EVENT_NAME = 'Sitter Favourited';
export const SITTER_UNFAVOURITE_EVENT_NAME = 'Sitter Unfavourited';
export enum SitterFavouriteSourcesEnum {
  FAVOURITES_PAGE = 'favourites_page',
  SITTER_PROFILE = 'sitter_profile',
  SFS_SITTER_CARD = 'sfs_sitter_card',
}

// Eppo Randomization
export const EPPO_RANDOMISED_ASSIGNMENT_EVENT_NAME = 'Eppo Randomised Assignment';
export const BROWSER_AUTOMATION_SIGNALS_OBSERVED_EVENT_NAME = 'Browser Automation Signals Observed';

// First Booking Promo Dialog
export const PROMO_MODAL_VIEWED_EVENT_NAME = 'Promo Modal Viewed';
export const PROMO_MODAL_CTA_CLICK_EVENT_NAME = 'Promo Modal CTA Click';
export const PROMO_BANNER_CTA_CLICK_EVENT_NAME = 'Promo Banner CTA Click';
export const PROMO_MODAL_DISMISSED_EVENT_NAME = 'Promo Modal Dismissed';

// Mobile app download banner
export const MOBILE_APP_DOWNLOAD_BANNER_VIEWED_EVENT_NAME = 'Mobile App Download Banner Viewed';
export const MOBILE_APP_DOWNLOAD_BANNER_CTA_CLICKED_EVENT_NAME =
  'Mobile App Download Banner CTA Clicked';
export const MOBILE_APP_DOWNLOAD_BANNER_CLOSED_EVENT_NAME = 'Mobile App Download Banner Closed';

// Booking Enquiry
export const SITTER_VIEW_CLICK_EVENT_NAME = 'Sitter View Click';
export const MADE_BOOKING_REQUEST_FE_EVENT_NAME = 'Made Booking Request FE';
export const BOOKING_ENQUIRY_CREATE_CLICK_EVENT_NAME = 'Booking Enquiry Create Click';
export const BOOKING_ENQUIRY_ADD_PET_CLICK_EVENT_NAME = 'Booking Enquiry Add Pet Click';
export const BOOKING_ENQUIRY_ADD_PHONE_CLICK_EVENT_NAME = 'Booking Enquiry Add Phone Click';

// Booking Payment
export const BOOKING_PAYMENT_COMPLETED = 'Made Payment FE';
export const BOOKING_PAYMENT_FAILED = 'Booking Payment Failed';
export const BOOKING_PAYMENT_AUTHORIZATION_REQUESTED = 'Booking Payment Authorization Requested';
// Keeping it similar to native mobile event name
export const BOOKING_PAYMENT_REVIEW_AND_PAY_CLICK = 'Booking Review & Pay Click';
export const BOOKING_PAYMENT_PAGE_REDIRECTED = 'Booking Payment Page Redirected';

// Peak Period
export const PEAK_PERIOD_PAGE_SUBMITTED_EVENT_NAME = 'Peak Period Page Submitted';

// Photo Gallery
export const PHOTO_GALLERY_UPLOADED_PHOTOS_EVENT_NAME = 'Photo Gallery Uploaded Photos';
export const PHOTO_GALLERY_DELETED_PHOTO_EVENT_NAME = 'Photo Gallery Deleted Photo';

// Become a Sitter Page
export const BECOME_A_SITTER_START_CLICK = 'Become a Sitter Start Click';
export const BECOME_A_SITTER_CANCEL_CLICK = 'Become a Sitter Cancel Click';

// Billing history page
export const BILLING_HISTORY_PAYMENT_REQUEST_CLICKED = 'Billing History Payment Request Clicked';

// Redeem balance page
export const REDEEM_BALANCE_PAYMENT_REQUEST_CLICKED = 'Redeem Balance Payment Request Clicked';
export const REDEEM_BALANCE_CONFIRM_ACCOUNT_CLICKED = 'Redeem Balance Confirm Account Clicked';
export const REDEEM_BALANCE_ACCOUNT_SAVED = 'Redeem Balance Account Saved';

// Booking RWB Review Page
export const BOOKING_RWB_REVIEW_SUBMITTED = 'Booking RWB Review Submitted';
export const BOOKING_RWB_REVIEW_SUBMIT_CLICK = 'Booking RWB Review Submit Click';

// Device Verification Page
export const CONTACT_VERIFICATION_SUCCESSFUL_EVENT_NAME = 'Contact Verification Successful';
export const CONTACT_VERIFICATION_FAILED_EVENT_NAME = 'Contact Verification Failed';

// Request Testimonial Page
export const REQUEST_TESTIMONIAL_SUBMITTED = 'Request Testimonial Submitted';
export const REQUEST_TESTIMONIAL_SUBMIT_CLICK = 'Request Testimonial Submit Click';

// Leave a Testimonial Page
export const LEAVE_TESTIMONIAL_SUBMITTED = 'Leave Testimonial Submitted';
export const LEAVE_TESTIMONIAL_SUBMIT_CLICK = 'Leave Testimonial Submit Click';

// Dashboard
// RV2's one dashboard event, for the stats article link.
export const SITTER_DASHBOARD_CLICKED_EVENT_NAME = 'Sitter dashboard clicked';
export const DASHBOARD_EDIT_PROFILE_CLICK_EVENT_NAME = 'Dashboard Edit Profile Click';
export const DASHBOARD_VIEW_PROFILE_CLICK_EVENT_NAME = 'Dashboard View Profile Click';
export const DASHBOARD_REQUEST_PAYMENT_CLICK_EVENT_NAME = 'Dashboard Request Payment Click';
export const DASHBOARD_REDEEM_CREDITS_CLICK_EVENT_NAME = 'Dashboard Redeem Credits Click';
export const DASHBOARD_INVITE_FRIEND_CLICK_EVENT_NAME = 'Dashboard Invite A Friend Click';
export const DASHBOARD_FIND_SITTER_CLICK_EVENT_NAME = 'Dashboard Find A Sitter Click';
export const DASHBOARD_BECOME_SITTER_APPLY_CLICK_EVENT_NAME =
  'Dashboard Become A Sitter Apply Click';
export const DASHBOARD_BECOME_SITTER_INFO_CLICK_EVENT_NAME = 'Dashboard Become A Sitter Info Click';
export const DASHBOARD_UPDATE_DETAILS_CLICK_EVENT_NAME = 'Dashboard Update Details Click';
export const DASHBOARD_UPDATE_SETTINGS_CLICK_EVENT_NAME = 'Dashboard Update Settings Click';
export const DASHBOARD_PET_EDIT_CLICK_EVENT_NAME = 'Dashboard Pet Edit Click';
export const DASHBOARD_VIEW_PETS_CLICK_EVENT_NAME = 'Dashboard View Pets Click';
export const DASHBOARD_POLICE_CHECK_APPLY_CLICK_EVENT_NAME = 'Dashboard Police Check Apply Click';
export const DASHBOARD_REQUEST_TESTIMONIALS_CLICK_EVENT_NAME =
  'Dashboard Request Testimonials Click';
export const DASHBOARD_BOOST_UPDATE_CALENDAR_CLICK_EVENT_NAME =
  'Dashboard Boost Update Calendar Click';
export const DASHBOARD_BOOST_VERIFY_CONTACT_CLICK_EVENT_NAME =
  'Dashboard Boost Verify Contact Click';
export const DASHBOARD_BOOST_UPLOAD_PHOTOS_CLICK_EVENT_NAME = 'Dashboard Boost Upload Photos Click';
export const DASHBOARD_RETURN_TO_APPLICATION_CLICK_EVENT_NAME =
  'Dashboard Return To Application Click';
export const DASHBOARD_BANNER_ADD_PHOTOS_CLICK_EVENT_NAME = 'Dashboard Banner Add Photos Click';
export const DASHBOARD_BANNER_ADD_PETS_CLICK_EVENT_NAME = 'Dashboard Banner Add Pets Click';
export const DASHBOARD_BANNER_UPDATE_CALENDAR_CLICK_EVENT_NAME =
  'Dashboard Banner Update Calendar Click';
export const DASHBOARD_BANNER_SET_PRICING_CLICK_EVENT_NAME = 'Dashboard Banner Set Pricing Click';
export const DASHBOARD_DOCUMENT_UPLOAD_CLICK_EVENT_NAME = 'Dashboard Document Upload Click';
export const DASHBOARD_DOCUMENT_UPLOADED_EVENT_NAME = 'Dashboard Document Uploaded';
export const DASHBOARD_DOCUMENT_DELETED_EVENT_NAME = 'Dashboard Document Deleted';

// Calendar
export const CALENDAR_IS_UPDATED_CLICK_EVENT_NAME = 'Calendar Is Updated Click';
export const CALENDAR_UPDATE_AVAILABILITY_CLICK_EVENT_NAME = 'Calendar Update Availability Click';
export const CALENDAR_HELP_CLICK_EVENT_NAME = 'Calendar Help Click';
export const CALENDAR_AVAILABILITY_MODAL_EDIT_CLICK = 'Calendar Availability Modal Edit Click';
export const CALENDAR_AVAILABILITY_AND_RATES_HELP_CLICK_EVENT_NAME =
  'Calendar Availability and Rates Help Click';
export const CALENDAR_UPDATED_EVENT_NAME = 'Calendar Updated';
export const CALENDAR_SETTINGS_UPDATED_EVENT_NAME = 'Calendar Settings Updated';

// Bookings (names shared with the native app unless noted)
// These four are the names RV2 already sends.
export const BOOKINGS_FILTERED_EVENT_NAME = 'Filtered bookings';
export const VIEWED_PRICE_BREAKDOWN_EVENT_NAME = 'Viewed price breakdown';
export const BOOKING_EDIT_BUTTON_CLICKED_EVENT_NAME = 'Clicked Edit Booking Button';
export const BOOKING_VIEW_DETAILS_CLICK_EVENT_NAME = 'Booking View Details Click';
export const BOOKING_APPROVE_CLICK_EVENT_NAME = 'Booking Approve Click';
export const BOOKING_DECLINE_CLICK_EVENT_NAME = 'Booking Decline Click';
export const BOOKING_CANCEL_CLICK_EVENT_NAME = 'Booking Cancel Click';
export const BOOKING_CONFIRM_STAY_CLICK_EVENT_NAME = 'Booking Confirm Stay Click';
export const BOOKING_REBOOK_CLICK_EVENT_NAME = 'Booking Rebook Click';
export const BOOKING_WRITE_REVIEW_CLICK_EVENT_NAME = 'Booking Write Review Click';
export const BOOKING_CONTACT_CLICK_EVENT_NAME = 'Booking Contact Click';
export const BOOKING_VIEW_CHAT_CLICK_EVENT_NAME = 'Booking View Chat Click';
// Web only.
export const BOOKING_VIEW_PHOTOS_CLICK_EVENT_NAME = 'Booking View Photos Click';
// Web only. Native uses 'Native - Booking Overview - Cancel paid booking'.
export const BOOKING_CANCEL_PAID_CLICK_EVENT_NAME = 'Booking Cancel Paid Click';
// Web only. The confirm step of a decline or cancellation, with the reason.
export const BOOKING_CANCELLATION_CONFIRM_CLICK_EVENT_NAME = 'Booking Cancellation Confirm Click';

// Messaging (names shared with the native app)
export const MESSAGES_SEND_CLICK_EVENT_NAME = 'Messages Send Click';
export const MESSAGES_VIEW_BOOKING_CHANGES_CLICK_EVENT_NAME = 'Messages View Booking Changes Click';
// Messaging, web only
export const MESSAGES_CONVERSATION_CLICK_EVENT_NAME = 'Messages Conversation Click';
export const MESSAGES_ARCHIVE_FILTER_CLICK_EVENT_NAME = 'Messages Archive Filter Click';
export const MESSAGES_ARCHIVE_CLICK_EVENT_NAME = 'Messages Archive Click';
export const MESSAGES_VIEW_BOOKING_DETAILS_CLICK_EVENT_NAME = 'Messages View Booking Details Click';

// Personal Details Page
export const PERSONAL_DETAILS_SUBMIT_CLICK = 'Personal Details Submit Click';
export const PERSONAL_DETAILS_SUBMITTED = 'Personal Details Submitted';
export const PERSONAL_DETAILS_VERIFY_CONTACT_CLICK = 'Personal Details Verify Contact Click';

// Services and Rates Page
export const SERVICES_AND_RATES_SERVICE_CLICK = 'Services and Rates Service Click';
export const SERVICES_AND_RATES_LEARN_MORE_CLICK = 'Services and Rates Learn More Click';

// Services Settings Page
export const SERVICES_SETTINGS_SUBMIT_CLICK = 'Services Settings Submit Click';
export const SERVICES_SETTINGS_SUBMITTED = 'Services Settings Submitted';
